import React from "react"

export default function ListApprove() {
	return (
		<div>
			<h2>ListApprove</h2>
		</div>
	)
}
